import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { createWeb3Modal } from "@web3modal/wagmi/react";

import { WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { config } from "./config";

import "./App.css";
import Page2Cre from "./components/page2_CRE/page2";
import Page2Slg from "./components/page2_SLG/page2";

// 0. Setup queryClient
const queryClient = new QueryClient();

// 1. Get projectId at https://cloud.walletconnect.com
const projectId = "0455f8bc86f40e4f7a5b6ba24aa1e20d";

// 3. Create modal
createWeb3Modal({
  wagmiConfig: config,
  projectId,
  includeWalletIds: [
    //"c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
    "e7c4d26541a7fd84dbdfa9922d3ad21e936e13a7a0e44385d44f006139e44d3b",
  ],
  enableAnalytics: true, // Optional - defaults to your Cloud configuration
  enableOnramp: true, // Optional - false as default
});

function App({ children }) {
  return (
    <QueryClientProvider client={queryClient}>
      <WagmiProvider config={config}>
        {children}
        <div className="App">
          <Router>
            <Routes>
              <Route path="/CRE" element={<Page2Cre />} />
              <Route path="/SLG" element={<Page2Slg />} />
            </Routes>
          </Router>
        </div>
      </WagmiProvider>
    </QueryClientProvider>
  );
}

export default App;
